/* ----------------------------------------------------
   FULL INDEX.JS — ROUTES + NAVIGATION
-----------------------------------------------------*/

import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import documoreLogo from "./documore-logo.png";
import Blogs from "./blogs";
import BlogPart0 from "./blogs/BlogPart0";
import BlogPart1 from "./blogs/BlogPart1";
import BlogPart2 from "./blogs/BlogPart2";
import BlogPart3 from "./blogs/BlogPart3";
import Services from "./Services";
import ServicePage from "./ServicePage";
import Privacy from "./Privacy";
import BlogMeta from "./BlogMeta";
import About from "./About";

import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  Outlet
} from "react-router-dom";


/* =======================================================
   NAVIGATION + LAYOUT
=======================================================*/
function Layout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">


      {/* ================= TOP NAV ================= */}
      <nav className="bg-[#0d2327] border-b border-[#0d2327]/50 sticky top-0 z-50">

        <div className="max-w-7xl mx-auto px-6 h-16 flex justify-between items-center">


          {/* LOGO */}
          <Link to="/" className="flex items-center gap-3">

            <img
              src={documoreLogo}
              alt="Documore"
              className="h-8 w-8"
            />

            <span className="text-white text-lg font-semibold">
              Documore
            </span>

          </Link>


          {/* ================= DESKTOP NAV ================= */}
          <div className="hidden md:flex items-center gap-8 text-sm font-medium">


            <Link
              to="/"
              className="text-gray-300 hover:text-white transition"
            >
              Home
            </Link>

            <Link to="/services" className="text-gray-300 hover:text-white transition">Capabilities</Link>

            <Link to="/blogs" className="text-gray-300 hover:text-white transition">Blogs</Link>


            <Link to="/about" className="text-gray-300 hover:text-white transition">About</Link>


            {/* CONTACT BUTTON */}
            <a
              href="/#contact"
              className="px-4 py-2 bg-white text-[#0d2327] font-semibold rounded-lg hover:bg-gray-200"
            >
              Contact
            </a>

           


            

          </div>


          {/* ================= MOBILE MENU ================= */}
          <div className="md:hidden relative">


            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="p-2 text-gray-200 hover:text-white"
            >

              <svg
                className="h-7 w-7"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {menuOpen ? (

                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />

                ) : (

                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 12h18M3 6h18M3 18h18"
                  />

                )}
              </svg>

            </button>


            {menuOpen && (

              <div className="absolute right-0 mt-2 w-72 bg-[#1b3a41] text-white border border-[#2a4f55] rounded-lg shadow-xl p-3 space-y-2 z-50">


                <Link
                  to="/"
                  onClick={() => setMenuOpen(false)}
                  className="block px-4 py-2 hover:bg-[#244d53] rounded"
                >
                  Home
                </Link>

                <Link
                  to="/services"
                  onClick={() => setMenuOpen(false)}
                  className="block px-4 py-2 hover:bg-[#244d53] rounded"
                >
                  Capabilities
                </Link>

                <Link
                  to="/blogs"
                  onClick={() => setMenuOpen(false)}
                  className="block px-4 py-2 hover:bg-[#244d53] rounded"
                >
                  Blogs
                </Link>

                


<Link
                  to="/about"
                  onClick={() => setMenuOpen(false)}
                  className="block px-4 py-2 hover:bg-[#244d53] rounded"
                >
                  About
                </Link>


                <a
                  href="/#contact"
                  onClick={() => setMenuOpen(false)}
                  className="block px-4 py-2 bg-[#2e6b74] hover:bg-[#38818c] font-semibold text-center rounded"
                >
                  Contact
                </a>

              </div>
            )}

          </div>

        </div>
      </nav>


      <Outlet />

    </div>
  );
}


/* ==================== 404 PAGE ==================== */
function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-10">
      <h1 className="text-3xl text-gray-800 font-semibold">
        404 — Page Not Found
      </h1>
    </div>
  );
}


/* ==================== ROOT ==================== */
const root = ReactDOM.createRoot(
  document.getElementById("root")
);


root.render(
  <React.StrictMode>

    <BrowserRouter>

      <Routes>

        <Route path="/" element={<Layout />}>

          <Route index element={<App />} />

          <Route path="services" element={<Services />} />
          <Route path="services/:slug" element={<ServicePage />} />
          <Route path="about" element={<About />} />
          <Route path="privacy" element={<Privacy />} />

          <Route path="blogs" element={<BlogMeta path="/blogs"><Blogs /></BlogMeta>} />

          <Route path="blogs/0" element={<BlogMeta path="/blogs/0"><BlogPart0 /></BlogMeta>} />
          <Route path="blogs/1" element={<BlogMeta path="/blogs/1"><BlogPart1 /></BlogMeta>} />
          <Route path="blogs/2" element={<BlogMeta path="/blogs/2"><BlogPart2 /></BlogMeta>} />
          <Route path="blogs/3" element={<BlogMeta path="/blogs/3"><BlogPart3 /></BlogMeta>} />

          <Route path="*" element={<NotFound />} />

        </Route>

      </Routes>

    </BrowserRouter>

  </React.StrictMode>
);

reportWebVitals();
